import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TodoIntegrationType } from '@demind-inc/core';
import { useRecoilState } from 'recoil';

import { tasksApi } from '../api';
import { taskErrorSnackBarAtom } from '../recoil';

interface UseSyncTodoProjectsParams {
  userId: string;
  todoType: TodoIntegrationType;
  targetOriginalBoardIds?: string[];
}

export function useSyncTodoProjects() {
  const queryClient = useQueryClient();
  const [_, setTaskErrorSnackbar] = useRecoilState(taskErrorSnackBarAtom);

  const syncTodoProjectsMutation = useMutation({
    mutationFn: ({ userId, targetOriginalBoardIds }: UseSyncTodoProjectsParams) => {
      return tasksApi.syncTodoProjects(userId, { targetOriginalBoardIds }).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.user'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.projects'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.tasks'] });
    },
    onError: (error, { todoType }) => {
      if (!!error) {
        // If todo integration failed, need to reconnect so returns 401 error.
        setTaskErrorSnackbar({
          status: 401,
          message: "Couldn't sync — try again?",
          provider: todoType,
        });
      }
    },
  });

  return {
    syncTodoProjects: syncTodoProjectsMutation.mutateAsync,
    ...syncTodoProjectsMutation,
  };
}
